export default "__VITE_ASSET__BbfPvLSr__"